import React, { useEffect, useMemo, useState } from "react";

import clsx from "clsx";

import styles from "./index.module.css";
import integrationsList from "./integrations-list";
import { itemSize } from "./item";
import List from "./list";

const cutList = (items: string[], index: number): string[] => {
  const movingItems = items.slice(0, index);
  const remainingItems = items.slice(index, items.length);
  return [...remainingItems, ...movingItems];
};

const IntegrationsScroller = () => {
  const [animate, setAnimate] = useState(false);
  const rows = useMemo(() => {
    const rowsCount = 3;
    const split = integrationsList.length / 3;
    const result: string[][] = [];

    for (let i = 0; i < rowsCount; i++) {
      result.push(cutList(integrationsList, (split + 1) * i));
    }

    return result;
  }, []);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <div
      className="w-full relative overflow-hidden whitespace-nowrap"
      style={{ height: rows.length * (itemSize * 0.9) }}
    >
      <div className={clsx(styles.scroller, animate && styles.animate)}>
        <List rows={rows} />
        <List rows={rows} />
      </div>
    </div>
  );
};

export default IntegrationsScroller;
